"use client";

import {FrontWebPodcastProgramModel} from "../../../generated";
import { RouteLink} from "../../RouteLink";
import routes from "../../../utils/routes";
import RadioCss from "../Style.module.scss";
import { LogoBox } from "../Image/LogoBox";
import { useRadio } from "../../../contexts/useRadio";


export const ProgramBox = (props: {
    className?: string,
    program: FrontWebPodcastProgramModel,
}) => {
    const hasRadio = useRadio();
    const url = hasRadio ? routes.radio_program_detail(hasRadio.slug, props.program.slug) : routes.program_detail(props.program.slug);

    return <RouteLink to={url} className={`${props.className ? props.className : ""} ${RadioCss.LinkBox} d-flex flex-column align-items-center text-center`}>
        <LogoBox src={props.program.logo} alt={props.program.logo} shadow={true}  />
        <strong>{props.program.name}</strong>
    </RouteLink>
}
